import { Link } from "react-router-dom";
import ConfigApi from "../../../utils/api/config/config.api";
import Logo from "../../assets/appImage/Logo.png";
import WhatsappImg from "../../assets/icons/icon-whatsapp.png";

import "./FrontFooter.css";

const FrontFooter = () => {
  const { data } = ConfigApi.useGetConfigQuery();

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="foot-grid">
          <div className="foot-brand">
            <Link to="/" className="brand" style={{ color: 'var(--ink)' }}>
              <div className="brand-mark">
                <img src={Logo} alt="Maajjal" style={{ padding: '6px', fontSize: '26px', objectFit: 'contain' }} />
              </div>
            </Link>
            <p>Lancez votre cagnotte, contribuez à des causes qui vous tiennent à cœur et vendez vos produits en un seul lieu.</p>
            <div className="foot-socials">
              <a href={data?.facebook || "#"} aria-label="Facebook"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-2.9h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.3 0-1.7.8-1.7 1.6V12H16l-.4 2.9h-2.3v7A10 10 0 0 0 22 12z" /></svg></a>
              <a href={data?.twitter || "#"} aria-label="Twitter"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" /></svg></a>
              <a href={data?.linkedin || "#"} aria-label="LinkedIn"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.3 18.3v-7.4H5.9v7.4h2.4zM7.1 9.8a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8zm11.2 8.5v-4.2c0-2-.4-3.5-2.8-3.5-1.2 0-2 .6-2.3 1.2v-1H11v7.4h2.4v-3.6c0-1 .2-1.9 1.4-1.9s1.2 1.1 1.2 2v3.5h2.3z" /></svg></a>
            </div>
          </div>

          <div className="foot-col">
            <h5>Navigation</h5>
            <ul>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/app/campagnes">Cagnottes</Link></li>
              <li><Link to="/app/lancer-une-campagne">Lancer un projet</Link></li>
              <li><Link to="/app/marketplace">Marketplace</Link></li>
              <li><Link to="/app/qui-sommes-nous">À propos</Link></li>
            </ul>
          </div>

          <div className="foot-col">
            <h5>Légal</h5>
            <ul>
              <li><Link to="/app/conditions-et-termes">Conditions</Link></li>
              <li><Link to="/app/mentions-legales">Mentions légales</Link></li>
            </ul>
          </div>

          <div className="foot-col">
            <h5>Contact</h5>
            <ul>
              <li><a href={`mailto:${data?.email}`}>
                {data?.email}
              </a></li>
              <li><Link to="/app/nous-contacter">Centre d'aide</Link></li>
              
            </ul>
          </div>
        </div>
        {!!data && (
                <a
                  href={`https://wa.me/${data?.phone2?.replace("+", "")}/`}
                  target="_blank"
                  className="btn btn-float-whatsapp"
                >
                  <img
                    src={WhatsappImg}
                    alt="icon whatsapp"
                    style={{ width: 100, height: 100, objectFit: "contain" }}
                  />
                </a>
              )}

        <div className="foot-bottom">
          <div className="copy">© {new Date().getFullYear()} Maajjal · Tous droits réservés</div>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;